import { instance } from 'api/api';
import { IndexDataArrayType } from 'app/editor/dataset/IndexManager';
import { YNValues } from 'tools/types';

export interface CheckInstanceDateResponse {
    status: 'OK' | 'ERROR';
    adjusted_date: string;
    exist: YNValues;
}

export const datasetAPI = {
    async checkInstanceDate(datasetId: string, date: string): Promise<CheckInstanceDateResponse> {
        const response = await instance.post(`data/editor/dataset/` + datasetId + `/check-instance-date`, {
            date: date,
        });

        return response.data;
    },
    import(datasetId: string, formData: object) {
        return instance.post(`data/editor/dataset/` + datasetId + `/import`, formData);
    },
    getIndexesData(datasetId: string) {
        return instance.post(`data/editor/dataset/` + datasetId + `/indexes`);
    },
    saveIndexesData(datasetId: string, data: { apply: boolean; indexes: IndexDataArrayType }) {
        return instance.post(`data/editor/dataset/` + datasetId + `/save-indexes`, data);
    },
};
